<template>
  <div direction="vertical" style="width: 1400px;" v-loading="fullScreenLock">
    <v-tour name="gameImportTour" :steps="gameImportTourSteps" :options="gameImportTourOptions"
      :callbacks="gameImportTourCallbacks"></v-tour>

    <div id="line1" style="display: flex">
      <div id="base-attribute" class="white-page">
        <!-- 绑定至attribute属性上 -->
        <el-form ref="attributeFormRef" :disabled="attributeFormDisable" :model="attribute" :rules="attributeRules"
          label-width="80px" style="margin-top: 10px;">
          <div id="input-attribute">
            <div class="base-attribute-line">
              <el-form-item label="基础攻击" prop="jcgj" label-width="100px">
                <el-input v-model="attribute.jcgj" style="width: 100px" placeholder="24383"></el-input>
              </el-form-item>
              <el-col :span="1"></el-col>
              <el-form-item label="武器伤害" prop="wqsh" label-width="100px">
                <el-col :span="11">
                  <el-form-item prop="wqshMin">
                    <el-input v-model="attribute.wqshMin" style="width: 65px;" placeholder="4653"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="wqshMax">
                    <el-input v-model="attribute.wqshMax" style="width: 65px;" placeholder="6382"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </div>

            <div class="base-attribute-line">
              <el-form-item label="基础会心" prop="jchx" label-width="100px">
                <el-input v-model="attribute.jchx" style="width: 100px" placeholder="24.51">
                  <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
                </el-input>
              </el-form-item>
              <el-col :span="1"></el-col>
              <el-form-item label="会心效果" prop="jchxxg" label-width="100px">
                <el-input v-model="attribute.jchxxg" style="width: 100px;" placeholder="176.52">
                  <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
                </el-input>
              </el-form-item>
            </div>

            <div class="base-attribute-line">
              <el-form-item label="基础无双" prop="jcws" label-width="100px">
                <el-input v-model="attribute.jcws" style="width: 100px;" placeholder="49.62">
                  <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
                </el-input>
              </el-form-item>
              <el-col :span="1"></el-col>

              <el-form-item label="基础破防" prop="jcpf" label-width="100px">
                <el-input v-model="attribute.jcpf" style="width: 100px;" placeholder="31.97">
                  <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i>
                </el-input>
              </el-form-item>
            </div>

            <div class="base-attribute-line">
              <el-form-item label="基础破招" prop="jcpz" label-width="100px">
                <el-input v-model="attribute.jcpz" style="width: 100px;" placeholder="6728"></el-input>
              </el-form-item>
              <el-col :span="1"></el-col>
              <el-form-item label="基础身法" prop="jcsf" label-width="100px">
                <el-input v-model="attribute.jcsf" style="width: 100px;" placeholder="5338"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <el-form ref="attributeButtonFormRef" label-width="80px">
          <div class="base-attribute-line">
            <el-form-item label="魔盒导入">
              <el-input type="textarea" v-model="attribute.import" style="width: 355px;"></el-input>
            </el-form-item>
          </div>
          <div class="base-attribute-line" id="attributeButtonCompent">
            <el-form-item style="text-align: right;margin-right: auto;margin-left: auto;margin-bottom: 0px;">
              <el-button type="info" @click="reset">重置</el-button>
              <el-button type="primary" @click="manualInput">手动录入</el-button>
              <el-button type="primary" @click="importData">魔盒导入</el-button>
              <br>
              <el-button type="warning" @click="recipeConfig">秘籍配置</el-button>
              <el-button type="success" @click="startGameImportTour">配装器使用导航</el-button>
              <el-button type="success" @click="peiZhuangOpen" data-v-step="0">配装器</el-button>
              <!-- <el-button>取消</el-button> -->
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div id="income" class="white-page">
        <!-- buff模块 -->
        <div id="buff-module">
          <div class="base-line">
            <el-checkbox v-model="income.buff.zuoXuanYouZhuan.enable" label="左旋右转" border style="margin-left: 0px;">
            </el-checkbox>
            <el-input v-if="income.buff.zuoXuanYouZhuan.enable" v-model="income.buff.zuoXuanYouZhuan.num"
              style="width: 75px; margin-left: 0px;" placeholder="36">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.hanRuLei.enable" label="撼如雷" border></el-checkbox>
            <el-checkbox v-model="income.buff.xiuQi.enable" label="袖气" border></el-checkbox>
            <el-checkbox v-model="income.buff.hanXiaoQianJun.enable" label="寒啸千军" border></el-checkbox>
            <el-checkbox v-model="income.buff.meiHuaSanNong.enable" label="梅花三弄" border></el-checkbox>
            <el-input v-if="income.buff.meiHuaSanNong.enable" v-model="income.buff.meiHuaSanNong.num"
              style="width: 75px; margin-left: 0px;" placeholder="36">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.xianWangGuDing.enable" label="仙王蛊鼎" border></el-checkbox>
          </div>
          <div class="base-line">
            <el-checkbox v-model="income.buff.sheShenHongFa.enable" label="舍身弘法" border style="margin-left: 0px;">
            </el-checkbox>
            <el-input v-if="income.buff.sheShenHongFa.enable" v-model="income.buff.sheShenHongFa.num"
              style="width: 65px; margin-left: 0px;" placeholder="36">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.haoLingSanJun.enable" label="号令三军" border></el-checkbox>
            <el-input v-if="income.buff.haoLingSanJun.enable" v-model="income.buff.haoLingSanJun.num"
              style="width: 65px; margin-left: 0px;" placeholder="48">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.zhenFen.enable" label="振奋" border></el-checkbox>
            <el-input v-if="income.buff.zhenFen.enable" v-model="income.buff.zhenFen.num"
              style="width: 65px; margin-left: 0px;" placeholder="60">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.jiuZhongXian.enable" label="酒中仙" border></el-checkbox>
            <el-checkbox v-model="income.buff.shuKuang.enable" label="疏狂" border></el-checkbox>
          </div>
          <div class="base-line">
            <el-checkbox v-model="income.buff.chaoShengYan.enable" label="朝圣言" border style="margin-left: 0px;"
              @change="selectChaoShengYan()"></el-checkbox>
            <el-input v-if="income.buff.chaoShengYan.enable" v-model="income.buff.chaoShengYan.num"
              style="width: 65px; margin-left: 0px;" placeholder="24">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.chaoShengYanGongJi.enable" label="朝圣言-攻击" border
              @change="selectChaoShengYanGongJi()"></el-checkbox>
            <el-input v-if="income.buff.chaoShengYanGongJi.enable" v-model="income.buff.chaoShengYanGongJi.num"
              style="width: 65px; margin-left: 0px;" placeholder="24">
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">层</i>
            </el-input>
            <el-checkbox v-model="income.buff.piaoHuang.enable" label="飘黄" border></el-checkbox>
          </div>
        </div>
        <!-- debuff模块 -->
        <div id="debuff-module">
          <div class="base-line">
            <el-checkbox v-model="debuff.chengLongJian.enable" label="乘龙箭" border></el-checkbox>
            <el-checkbox v-model="debuff.longYin.enable" label="龙吟" border></el-checkbox>
            <el-checkbox v-model="debuff.qiuSu.enable" label="秋肃" border></el-checkbox>
            <el-checkbox v-model="debuff.xuRuo.enable" label="虚弱" border></el-checkbox>
          </div>
        </div>
        <!-- 小吃模块 -->
        <div id="drug-module">
          <div class="base-line">
            <div class="tag-text">增强小药</div>
            <el-select v-model="income.drug.zqxy" placeholder="请选择" clearable>
              <el-option v-for="zqxy in listData.drug.zqxyOptions" :key="zqxy.id" :label="zqxy.name"
                :value="zqxy.id"></el-option>
            </el-select>

            <div class="tag-text">增强小吃</div>
            <el-select v-model="income.drug.zqxc" placeholder="请选择" clearable>
              <el-option v-for="zqxc in listData.drug.zqxcOptions" :key="zqxc.id" :label="zqxc.name"
                :value="zqxc.id"></el-option>
            </el-select>

            <div class="tag-text">辅助小药</div>
            <el-select v-model="income.drug.fzxy" placeholder="请选择" clearable>
              <el-option v-for="zqxy in listData.drug.fzxyOptions" :key="zqxy.id" :label="zqxy.name"
                :value="zqxy.id"></el-option>
            </el-select>

            <div class="tag-text">辅助小吃</div>
            <el-select v-model="income.drug.fzxc" style="width:160px" placeholder="请选择" clearable>
              <el-option v-for="fzxc in listData.drug.fzxcOptions" :key="fzxc.id" :label="fzxc.name"
                :value="fzxc.id"></el-option>
            </el-select>
          </div>
          <div class="base-line">
            <div class="tag-text">武器磨石</div>
            <el-select v-model="income.drug.wqms" placeholder="请选择" clearable>
              <el-option v-for="wqms in listData.drug.wqmsOptions" :key="wqms.id" :label="wqms.name"
                :value="wqms.id"></el-option>
            </el-select>

            <div class="tag-text">家园小吃</div>
            <el-select v-model="income.drug.jyxc" placeholder="请选择" clearable>
              <el-option v-for="jyxc in listData.drug.jyxcOptions" :key="jyxc.id" :label="jyxc.name"
                :value="jyxc.id"></el-option>
            </el-select>

            <div class="tag-text">家园小酒</div>
            <el-select v-model="income.drug.jyxj" placeholder="请选择" clearable>
              <el-option v-for="jyxj in listData.drug.jyxjOptions" :key="jyxj.id" :label="jyxj.name"
                :value="jyxj.id"></el-option>
            </el-select>

            <div class="tag-text">团队宴席</div>
            <el-select multiple collapse-tags v-model="income.drug.tdyx" @change="selectTdyx" style="width:160px"
              placeholder="请选择">
              <el-option v-for="tdyx in listData.drug.tdyxOptions" :disabled="tdyx.disable" :key="tdyx.id"
                :label="tdyx.name" clearable :value="tdyx.id"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="loop.dataSource == 'page'">
          <!-- 装备模块 -->
          <div id="equipment-module">
            <div class="base-line">
              <div class="tag-text">门派套装</div>
              <el-select v-model="income.equipment.suit" placeholder="请选择" multiple collapse-tags style="width:160px">
                <el-option v-for="suit in listData.equipment.suitOptions" :key="suit.code" :label="suit.name"
                  :value="suit.code"></el-option>
              </el-select>

              <div class="tag-text">特效腰坠</div>
              <el-select v-model="income.equipment.pendant" placeholder="请选择" clearable>
                <el-option v-for="pendant in listData.equipment.pendantOptions" :key="pendant.code"
                  :label="pendant.name" :value="pendant.code"></el-option>
              </el-select>

              <div class="tag-text">特效武器</div>
              <el-select v-model="income.equipment.weapon" placeholder="请选择" clearable>
                <el-option v-for="weapon in listData.equipment.weaponOptions" :key="weapon.code" :label="weapon.name"
                  :value="weapon.code"></el-option>
              </el-select>
            </div>
          </div>
          <!-- 大附魔模块 -->
          <div id="great-enchantment-module">
            <div class="base-line">
              <el-checkbox v-model="income.greatEnchantment.cap" label="头附魔" border></el-checkbox>
              <el-checkbox v-model="income.greatEnchantment.clothing" label="衣附魔" border></el-checkbox>
              <el-checkbox v-model="income.greatEnchantment.waistband" label="腰附魔" border></el-checkbox>
              <el-checkbox v-model="income.greatEnchantment.wrister" label="手附魔" border></el-checkbox>
              <el-checkbox v-model="income.greatEnchantment.shoe" label="脚附魔" border></el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="line2" style="display: flex">
      <div id="loop" class="white-page">
        <div class="base-line" style="margin-top: 10px;">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">目标等级:</div>
            <el-select v-model="loop.enemy.level" placeholder="请选择">
              <el-option v-for="level in listData.enemy" :key="level.code" :label="level.name"
                :value="level.code"></el-option>
            </el-select>
          </div>
        </div>
        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">阵眼:</div>
            <el-select v-model="income.position" placeholder="请选择" style="width: 145px;" @click.native="() => {
              $refs.attributeFormRef.validate(async valid => {
                if (valid) {
                  contrastPositionOption();
                }
              });
            }" clearable>
              <el-option v-for="position in listData.position.positionOptions" :key="position.code"
                :label="position.name" :value="position.code">
                <CommonOption :itemProp="position">
                </CommonOption>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">使用循环:</div>
            <el-select v-model="loop.loopType" placeholder="请选择">
              <el-option v-for="loop in listData.loop.loopTypeOptions" :key="loop.code" :label="loop.name"
                :value="loop.code">

              </el-option>
            </el-select>
          </div>
        </div>
        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">网络延迟:</div>
            <el-select v-model="loop.delay" placeholder="请选择">
              <el-option v-for="delay in listData.loop.delayOptions" :key="delay.code" :label="delay.name"
                :value="delay.code"></el-option>
            </el-select>
          </div>
        </div>

        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">计算策略:</div>
            <el-select v-model="loop.computeStrategy" placeholder="请选择">
              <el-option v-for="computeStrategy in listData.loop.computeStrategyOptions" :key="computeStrategy.code"
                :label="computeStrategy.name" :value="computeStrategy.code"></el-option>
            </el-select>
          </div>
        </div>

        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <div class="tag-text">数据来源:</div>
            <el-select v-model="loop.dataSource" placeholder="请选择">
              <el-option @click.native="changeDataSource(dataSource)"
                v-for="dataSource in listData.loop.dataSourceOptions" :key="dataSource.code" :label="dataSource.name"
                :value="dataSource.code"></el-option>
            </el-select>
          </div>
        </div>

        <!-- <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <el-tooltip class="item" effect="dark" content="使用左上角输入的属性计算" placement="top-start">
              <el-button type="primary" @click="preComputeDps()">数据计算</el-button>
            </el-tooltip>
          </div>
        </div> -->
        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <!-- <el-tooltip class="item" effect="dark" content="使用配装器属性配置的属性计算" placement="top-start"> -->
            <el-button type="success" @click="clickComputeDps()">伤害计算</el-button>
            <!-- </el-tooltip> -->
          </div>
        </div>
        <div class="base-line">
          <div style="margin-left: auto;margin-right: auto;">
            <el-button type="danger" @click="allBuff()">拉满！</el-button>
            <el-button type="info" @click="clearBuff()">重置buff</el-button>
          </div>
        </div>
        <div class="base-line">
          <p style="font-size: 14px;line-height: 16px;"></p>
        </div>
        <div class="base-line">
          <el-link type="primary" style="text-align: center;margin-left: auto;margin-right: auto;line-height: 20px;"
            href="https://www.bilibili.com/video/BV1cZ421T7jP/?vd_source=d82c712dad88629a3309883b6905db8e"
            target="_blank">紫武遗恨循环地址</el-link>
          <el-link type="primary" style="text-align: center;margin-left: auto;margin-right: auto;line-height: 20px;"
            href="https://www.bilibili.com/video/BV1Ny411B7ih/?vd_source=d82c712dad88629a3309883b6905db8e"
            target="_blank">特效遗恨循环地址</el-link>
        </div>
        <div class="base-line">
          <el-link type="primary" style="text-align: center;margin-left: auto;margin-right: auto;line-height: 20px;"
            href="https://www.jx3box.com/bps/67887" target="_blank">攻略地址</el-link>
        </div>
      </div>
      <div id="attributeIncome" class="white-page">
        <div id="attributeIncomeBar" style="width: 100%;height: 450px;"></div>
      </div>
      <div id="skillNum" class="white-page">
        <div id="dpsFont">dps:{{ result.dps.dps }}</div>
        <div id="dpsBar" style="width: 100%;height: 450px;"></div>
      </div>
    </div>



    <PeiZhuangDialog ref="peiZhuangDialogRef" @confirm="peiZhuangConfirm"></PeiZhuangDialog>
    <Recipe ref="recipeDialogRef" :recipeProp="recipe" @confirm="recipeConfirm"> </Recipe>

  </div>
</template>

<script>
import * as echarts from "echarts";
import { Mixins } from "../minixs/DuanYou";

import { Constant } from "../minixs/Constant";
import * as copyUtils from "../minixs/CopyUtils"
import * as equipApi from "../api/EquipApi"
import * as duanYouApi from "../api/DuanYouApi"
import Recipe from "../components/RecipeDialog.vue"
import CommonOption from "./CommonOption.vue"

import PeiZhuangDialog from "./peiZhuang/PeiZhuangDialog.vue"





export default {
  components: { Recipe, PeiZhuangDialog, CommonOption },
  mixins: [Mixins, Constant],
  data() {
    return {
      fullScreenLock: true,
      gameImportTourOptions: {
        highlight: true,
        dialogVisible: false,
        useKeyboardNavigation: false, //不使用->,<-
        labels: {
          buttonSkip: '跳过',
          buttonPrevious: '上一步',
          buttonNext: '下一步',
          buttonStop: '关闭'
        }
      },
      gameImportTourSteps: [
        {
          target: '[data-v-step="0"]',
          content: `游戏导入功能指南，若不需要请关闭w</br>1、进入配装器`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="1"]',
          content: `2、进入装备导入`,
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            this.peiZhuangOpen();
            resolve();
          })
        },
        {
          target: '[data-v-step="2"]',
          content: `3、选择服务器`,
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            this.$refs.peiZhuangDialogRef.openPeiZhuangImportDialog();
            resolve();
          })
        },
        {
          target: '[data-v-step="3"]',
          content: `4、输入用户名`,
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            this.$refs.peiZhuangDialogRef.$refs.peiZhuangImportDialogRef.game.serverKey = [];
            this.$refs.peiZhuangDialogRef.$refs.peiZhuangImportDialogRef.game.serverKey.push("电信区");
            this.$refs.peiZhuangDialogRef.$refs.peiZhuangImportDialogRef.game.serverKey.push("梦江南");
            resolve();
          })
        },
        {
          target: '[data-v-step="4"]',
          content: `5、点击查询`,
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            this.$refs.peiZhuangDialogRef.$refs.peiZhuangImportDialogRef.game.roleName = "猜猜我是谁";
            resolve();
          })
        },
        {
          target: '[data-v-step="5"]',
          content: `6、点击导入`,
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            this.$refs.peiZhuangDialogRef.$refs.peiZhuangImportDialogRef.queryRole();
            resolve();
          })
        },
      ],

      gameImportTourCallbacks: { //可以自定义回调函数，做一些自己的操作
        onPreviousStep: this.previousStepCallback,
        onNextStep: this.nextStepCallback
      },

      attributeFormDisable: false,
      attribute: {
        jcgj: '',
        jcld: 41,
        wqsh: '1',
        wqshMin: '',
        wqshMax: '',
        jchx: '',
        jchxxg: '',
        jcws: '',
        jcpf: '',
        jcpz: '',
        jcsf: '',
        // 导入数据对话框
        import: '{"Vitality":36991,"Agility":7254,"Spirit":41,"Spunk":41,"Strength":41,"PhysicsAttackPowerBase":32665,"PhysicsAttackPower":43546,"PhysicsCriticalStrikeRate":0.5020954561353302,"PhysicsCriticalStrike":39476,"PhysicsCriticalDamagePowerPercent":1.9445572668211348,"PhysicsCriticalDamagePower":5353,"PhysicsOvercomePercent":0.5262106903240167,"StrainPercent":0.4208457411199821,"HastePercent":0,"SurplusValue":5058,"MaxHealth":519085,"PhysicsShieldPercent":0.08166478083337433,"LunarShieldPercent":0.07032222720254992,"ToughnessDefCriticalPercent":0,"DecriticalDamagePercent":0.1,"MeleeWeaponAttackSpeed":24,"MeleeWeaponDamage":3629,"MeleeWeaponDamageRand":2419,"PVXAllRound":0,"PhysicsOvercome":41372,"Strain":31904,"Haste":0,"EquipList":{"HAT":{"id":"7_98334","stone":"","enchant":12206,"enhance":12056,"strength":6,"embedding":[8,8]},"BELT":{"id":"7_98274","stone":"","enchant":12202,"enhance":12173,"strength":6,"embedding":[8,8]},"SHOES":{"id":"7_98304","stone":"","enchant":12203,"enhance":12111,"strength":6,"embedding":[8,8]},"WRIST":{"id":"7_98455","stone":"","enchant":12204,"enhance":12109,"strength":3,"embedding":[8,8]},"JACKET":{"id":"7_98364","stone":"","enchant":12205,"enhance":12172,"strength":6,"embedding":[8,8]},"RING_1":{"id":"8_39862","stone":"","enchant":"","enhance":12182,"strength":3,"embedding":[]},"RING_2":{"id":"8_39862","stone":"","enchant":"","enhance":12182,"strength":3,"embedding":[]},"BOTTOMS":{"id":"7_98465","stone":"","enchant":"","enhance":12054,"strength":3,"embedding":[8,8]},"PENDANT":{"id":"8_39855","stone":"","enchant":"","enhance":12176,"strength":4,"embedding":[8]},"NECKLACE":{"id":"8_39837","stone":"","enchant":"","enhance":12174,"strength":6,"embedding":[8]},"PRIMARY_WEAPON":{"id":"6_37247","stone":843,"enchant":"","enhance":12042,"strength":4,"embedding":[8,8,8]},"SECONDARY_WEAPON":{"id":"6_37188","stone":"","enchant":"","enhance":12189,"strength":6,"embedding":[8]}},"Title":"【雾海寻龙】水特效配装","TalentCode":[{"id":22560,"name":"秋霁"},{"id":22562,"name":"雪覆"},{"id":26760,"name":"遗恨"},{"id":22571,"name":"风骨"},{"id":23309,"name":"北阙"},{"id":22575,"name":"渊岳"},{"id":22579,"name":"玄肃"},{"id":29166,"name":"飞刃回转"},{"id":22593,"name":"百节"},{"id":22587,"name":"忘断"},{"id":22596,"name":"徵逐"},{"id":22603,"name":"青山共我"}],"Mount":10585}',
        // 点击导入按钮之后的数据
        importData: ''
      },
      extraPoint: {
        guLu: [
          'qiuJi', // 秋霁
          'xuefu', // 雪覆
          'zheYi', // 折意
          'fengGu', // 风骨
          'beiQue', // 北阙
          'yuanYue', // 渊岳
          'xuanSu', // 玄肃
          'feiRenHuiZhuan', // 飞刃回转
          'baiJie', //百节
          'wangDuan', // 望断
          'zhiZhu', //徵逐
          'guLu', // 孤路
        ],
      },
      recipe: {
        recipeDialog: false,
        recipeSelect: null
      },
      attributeRules: {
        jcgj: {
          required: true,
          message: '请填写基础攻击',
          trigger: 'blur'
        },
        wqsh: {
          required: true,
          message: ' ',
          trigger: 'blur'
        },
        wqshMin: {
          required: true,
          message: '请填写武伤',
          trigger: 'blur'
        },
        wqshMax: {
          required: true,
          message: '请填写武伤',
          trigger: 'blur'
        },
        jchx: {
          required: true,
          message: '请填写基础会心',
          trigger: 'blur'
        },
        jchxxg: {
          required: true,
          message: '请填写会心效果',
          trigger: 'blur'
        },
        jcws: {
          required: true,
          message: '请填写基础无双',
          trigger: 'blur'
        },
        jcpf: {
          required: true,
          message: '请填写基础破防',
          trigger: 'blur'
        },
        jcpz: {
          required: true,
          message: '请填写基础破招',
          trigger: 'blur'
        },
        jcsf: {
          required: true,
          message: '请填写基础身法',
          trigger: 'blur'
        },
        import: ''
      },
      income: {
        drug: {
          zqxy: null,
          zqxc: null,
          fzxy: null,
          fzxc: null,
          wqms: null,
          jyxc: null,
          jyxj: null,
          tdyx: null
        },
        buff: {
          hanRuLei: {
            code: "hanRuLei",
            enable: false,
            num: 1,
            coverage: 1
          },
          zuoXuanYouZhuan: {
            code: "zuoXuanYouZhuan",
            enable: false,
            num: 120,
            coverage: 1
          },
          zhenFen: {
            code: "zhenFen",
            enable: false,
            num: 86,
            coverage: 1
          },
          xiuQi: {
            code: "xiuQi",
            enable: false,
            num: 1,
            coverage: 1
          },
          hanXiaoQianJun: {
            code: "hanXiaoQianJun",
            enable: false,
            num: 1,
            coverage: 0.5
          },
          meiHuaSanNong: {
            code: "meiHuaSanNong",
            enable: false,
            num: 120,
            coverage: 0.8
          },
          xianWangGuDing: {
            code: "xianWangGuDing",
            enable: false,
            num: 1,
            coverage: 0.208
          },
          sheShenHongFa: {
            code: "sheShenHongFa",
            enable: false,
            num: 36,
            coverage: 0.5
          },
          haoLingSanJun: {
            code: "haoLingSanJun",
            enable: false,
            num: 48,
            coverage: 0.1
          },
          jiuZhongXian: {
            code: "jiuZhongXian",
            enable: false,
            num: 1,
            coverage: 1
          },
          shuKuang: {
            code: "shuKuang",
            enable: false,
            num: 1,
            coverage: 0.24
          },
          chaoShengYan: {
            code: "chaoShengYan",
            enable: false,
            num: 24,
            coverage: 0.045
          },
          chaoShengYanGongJi: {
            code: "chaoShengYanGongJi",
            enable: false,
            num: 24,
            coverage: 0.045
          },
          piaoHuang: {
            code: "38581",
            enable: false,
            num: 1,
            coverage: 0.22
          },
        },
        equipment: {
          suit: null,
          weapon: null,
          cutCake: null,
          pendant: null
        },
        greatEnchantment: {
          cap: false,
          clothing: false,
          waistband: false,
          wrister: false,
          shoe: false
        },
        position: null
      },
      debuff: {
        chengLongJian: {
          code: "chengLongJian",
          enable: false,
          num: 1,
          coverage: 0.33
        },
        longYin: {
          code: "longYin",
          enable: false,
          num: 1,
          coverage: 1
        },
        qiuSu: {
          code: "qiuSu",
          enable: false,
          num: 1,
          coverage: 1
        },
        xuRuo: {
          code: "xuRuo",
          enable: false,
          num: 1,
          coverage: 1
        }
      },
      result: {
        attributeIncome: {
          jcgj: "0",
          wqsh: "0",
          jchx: "0",
          jchxxg: "0",
          jcws: "0",
          jcpf: "0",
          jcpz: "0",
          jcsf: "0"
        },
        dps: {
          dps: null,
          dpsBarX: [],
          dpsBarY: [],
          dpsBarAll: [],
        }
      },
      loop: {
        enemy: {
          level: "muZhuang124"
        },
        loopType: "lxgBaoBaiJieYiHenLoop",
        delay: "60ms",
        computeStrategy: "commonComputeStrategyImpl",
        dataSource: "page"
      },
      ui: {
        showImg: true,
        activeIndex: '1'
      },
      equip: {
        hatList: [],
        jacketList: [],
        beltList: [],
        wristList: [],
        bottomsList: [],
        shoesList: [],
        necklaceList: [],
        pendantList: [],
        ring1List: [],
        ring2List: [],
        secondaryWeaponList: [],
        primaryWeaponList: [],
      }
    };
  },
  methods: {
    // 配装器导航开启
    startGameImportTour() {
      this.$tours['gameImportTour'].start();
    },
    previousStepCallback(currentStep) {
      if (currentStep == 1) {
        this.$refs.peiZhuangDialogRef.open();
      }
    },
    nextStepCallback(currentStep) {
      if (currentStep == 3) {

      }
    },

    importData() {
      if (!this.attribute.import) {
        alert("导入数据不能为空");
      } else if (false) { } else {
        try {
          var jsonObject = JSON.parse(this.attribute.import);
          this.attribute.jcgj = jsonObject.PhysicsAttackPowerBase;
          this.attribute.jchx = parseFloat(
            jsonObject.PhysicsCriticalStrikeRate * 100
          ).toFixed(2);
          this.attribute.wqshMin = jsonObject.MeleeWeaponDamage;
          this.attribute.wqshMax =
            jsonObject.MeleeWeaponDamageRand + jsonObject.MeleeWeaponDamage;
          this.attribute.jchxxg = parseFloat(
            jsonObject.PhysicsCriticalDamagePowerPercent * 100
          ).toFixed(2);
          this.attribute.jcws = parseFloat(
            jsonObject.StrainPercent * 100
          ).toFixed(2);
          this.attribute.jcpf = parseFloat(
            jsonObject.PhysicsOvercomePercent * 100
          ).toFixed(2);
          this.attribute.jcpz = jsonObject.SurplusValue;
          this.attribute.jcsf = jsonObject.Agility;


          // 获取魔盒装备列表
          var equipList = jsonObject.EquipList;
          // 获取装备下拉列表
          var equipemntOption = this.listData.equipment;

          // 导入特效腰坠
          // 清除特效腰坠
          this.income.equipment.pendant = null;
          var pendant = equipList.PENDANT;
          if (pendant != null) {
            var pendantOptions = equipemntOption.pendantOptions;
            // 获取魔盒腰坠id
            var pendantId = pendant.id;
            for (var pendantOption of pendantOptions) {
              if (pendantId.includes(pendantOption.code)) {
                this.income.equipment.pendant = pendantOption.code;
              }
            }
          }

          // 导入特效武器
          // 清除特效武器
          this.income.equipment.weapon = null;
          var primaryWeapon = equipList.PRIMARY_WEAPON;
          if (pendant != null) {
            var weaponOptions = equipemntOption.weaponOptions;
            // 获取武器id
            var primaryWeaponId = primaryWeapon.id;
            for (var weaponOption of weaponOptions) {
              if (primaryWeaponId.includes(weaponOption.code)) {
                this.income.equipment.weapon = weaponOption.code;
              }
              // 鬓间黄泉特殊处理
              if (primaryWeaponId.includes("37068")) {
                this.income.equipment.weapon = "37099";
              }
            }
          }

          // 清除套装效果
          this.income.equipment.suit = [];
          var setMap = new Map();

          var hat = equipList.HAT;
          if (hat != null) {
            // TODO 目前页面只有最新大附魔 以后更新一下
            if (hat.enchant != null) {
              this.income.greatEnchantment.cap = true;
            } else {
              this.income.greatEnchantment.cap = false;
            }
            // 寻找该装备
            for (var hatOption of this.equip.hatList) {
              if (hat.id.includes(hatOption.id)) {
                this.computeSetForImport(hatOption, setMap);
              }
            }
          }

          var jacket = equipList.JACKET;
          if (jacket != null) {
            // TODO 目前页面只有最新大附魔 以后更新一下 
            if (jacket.enchant != null) {
              this.income.greatEnchantment.clothing = true;
            } else {
              this.income.greatEnchantment.clothing = false;
            }
            // 寻找该装备
            for (var jacketOption of this.equip.jacketList) {
              if (jacket.id.includes(jacketOption.id)) {
                this.computeSetForImport(jacketOption, setMap);
              }
            }
          }

          var belt = equipList.BELT;
          if (belt != null) {
            // TODO 目前页面只有最新大附魔 以后更新一下 
            if (belt.enchant != null) {
              this.income.greatEnchantment.waistband = true;
            } else {
              this.income.greatEnchantment.waistband = false;

            }
            for (var beltOption of this.equip.beltList) {
              if (belt.id.includes(beltOption.id)) {
                this.computeSetForImport(beltOption, setMap);
              }
            }
          }

          var wrist = equipList.WRIST;
          if (wrist != null) {
            // TODO 目前页面只有最新大附魔 以后更新一下 
            if (wrist.enchant != null) {
              this.income.greatEnchantment.wrister = true;
            } else {
              this.income.greatEnchantment.wrister = false;
            }

            for (var wristOption of this.equip.wristList) {
              if (wrist.id.includes(wristOption.id)) {
                this.computeSetForImport(wristOption, setMap);
              }
            }
          }

          var shoes = equipList.SHOES;
          if (shoes != null) {
            // TODO 目前页面只有最新大附魔 以后更新一下 
            if (shoes.enchant != null) {
              this.income.greatEnchantment.shoe = true;
            } else {
              this.income.greatEnchantment.shoe = false;
            }
            for (var shoesOption of this.equip.shoesList) {
              if (shoes.id.includes(shoesOption.id)) {
                this.computeSetForImport(shoesOption, setMap);
              }
            }
          }


          this.attribute.importData = JSON.stringify(jsonObject);
          // 不允许手动输入
          this.attributeFormDisable = true;

          this.loop.dataSource = "page";
          this.cookiesSave();
        } catch (e) {
          alert("请确保导入的格式正确");
        }

        // const sos = `阿尤！不错哦`;
        // const synth = window.speechSynthesis;
        // let msg = new SpeechSynthesisUtterance(sos);
        // console.log(msg);
        // synth.speak(msg);
      }
    },
    // 页面导入功能计算套装效果
    computeSetForImport(equip, setMap) {
      let setId = equip.setId;
      if (setId == null) {
        return;
      }
      let num = setMap.get(setId);
      if (num == null || num == 0) {
        num = 1;
        setMap.set(setId, num);
      } else {
        setMap.set(setId, ++num);
      }
      for (var set of equip.equipOptionSetVoList) {
        if (num == set.triggerLevel) {
          if ("atSetEquipmentRecipe" == set.code || "atSkillEventHandler" == set.code) {
            // 导入套装效果
            for (var suit of this.listData.equipment.suitOptions) {
              if (suit.code == set.value && this.income.equipment.suit.indexOf(set.value) != null) {
                this.income.equipment.suit.push(String(set.value));
              }
            }
          }
        }
      }
    },
    reset() {
      this.init();
      this.$refs.attributeFormRef.resetFields();
      this.manualInput();
    },
    manualInput() {
      this.loop.dataSource = "page";
      this.attribute.importData = null;
      this.attributeFormDisable = false;
    },
    changeDataSource(dataSource) {
    },
    clickComputeDps() {
      if (this.loop.dataSource == 'page') {
        this.preComputeDps();
      } else {
        this.computePeiZhuangDps();
      }
    },
    // 判断是不是页面数据
    async dataSourceIsPage() {
      return 'page' == this.loop.dataSource;
    },
    // 对比阵眼收益
    async contrastPositionOption() {
      let req = {
        computeReqDto: this.dataSourceIsPage() ? await this.buildComputeDpsArgs() : await this.$refs.peiZhuangDialogRef.buildComputeDpsArgsForPz(),
      };
      const { data: response } = await this.$http.post("/peiZhuang/contrastPositionDps", req);
      var contrastResult = response.data;

      for (var position of this.listData.position.positionOptions) {
        for (var positionAdd of contrastResult) {
          if (position.code == positionAdd.code) {
            position.damageAddition = positionAdd.damageAddition;
          }
        }
      }

    },
    preComputeDps() {
      this.$refs.attributeFormRef.validate(async valid => {
        if (!valid) {
          return;
        }
        var req = await this.buildComputeDpsArgs()
        this.computeDps(req);
      });
    },
    computePeiZhuangDps() {
      this.$refs.peiZhuangDialogRef.computePeiZhuangDps();
    },
    async buildComputeDpsArgs() {
      var enchant2List = [];
      // 添加附魔信息
      if (this.income.greatEnchantment.cap) {
        enchant2List.push(this.constant.web.enchant.cap);
      }
      if (this.income.greatEnchantment.clothing) {
        enchant2List.push(this.constant.web.enchant.clothing);
      }
      if (this.income.greatEnchantment.waistband) {
        enchant2List.push(this.constant.web.enchant.waistband);
      }
      if (this.income.greatEnchantment.wrister) {
        enchant2List.push(this.constant.web.enchant.wrister);
      }
      if (this.income.greatEnchantment.shoe) {
        enchant2List.push(this.constant.web.enchant.shoe);
      }

      var req = {
        playerReqDto: {
          attributeReqDto: {
            jcgj: this.attribute.jcgj - Math.floor(41 * 0.15),
            jcld: 41,
            wqshMin: this.attribute.wqshMin,
            wqshMax: this.attribute.wqshMax,
            jchx: Number(this.attribute.jchx) / 100 * this.constant.criticalStrikeRate - Math.floor((this.attribute.jcsf * 0.64)),
            jchxxg: Number(this.attribute.jchxxg - this.constant.criticalDamagePowerRateBase) / 100 * this.constant.criticalDamagePowerRate,
            jcws: Number(this.attribute.jcws) / 100 * this.constant.atStrainRate,
            jcpf: Number(this.attribute.jcpf) / 100 * this.constant.overcomeRate - Math.floor((this.attribute.jcsf * 481 / 1024)) - Math.floor((41 * 0.3)),
            jcpz: Number(this.attribute.jcpz),
            jcsf: Number(this.attribute.jcsf),
          },
          extraPointList: this.listData.loop.extraPointMap.get(this.loop.loopType),
          buffReqDtoList: this.income.buff,
          drugList: [
            this.income.drug.zqxy,
            this.income.drug.zqxc,
            this.income.drug.fzxy,
            this.income.drug.fzxc,
            this.income.drug.jyxc,
            this.income.drug.jyxj,
          ],
          enchant1List: [
            this.income.drug.wqms,
          ],
          recipeList: [],
          setList: this.income.equipment.suit,
          equipmentList: [
            this.income.equipment.weapon,
            this.income.equipment.pendant
          ],
          enchant2List: enchant2List,
          buffReqDtoList: [
            this.income.buff.hanRuLei,
            this.income.buff.zuoXuanYouZhuan,
            this.income.buff.zhenFen,
            this.income.buff.xiuQi,
            this.income.buff.hanXiaoQianJun,
            this.income.buff.meiHuaSanNong,
            this.income.buff.xianWangGuDing,
            this.income.buff.sheShenHongFa,
            this.income.buff.haoLingSanJun,
            this.income.buff.jiuZhongXian,
            this.income.buff.shuKuang,
            this.income.buff.chaoShengYan,
            this.income.buff.chaoShengYanGongJi,
            this.income.buff.piaoHuang
          ],
          position: this.income.position,
          pzEquipmentReqDtoList: [],
          stone: null,
          isWuJie: false
        },
        enemyReqDto: {
          sectName: this.loop.enemy.level,
          deBuffReqDtoList: [
            this.debuff.chengLongJian,
            this.debuff.longYin,
            this.debuff.qiuSu,
            this.debuff.xuRuo
          ]
        },
        loopReqDto: {
          computeStrategy: this.loop.computeStrategy,
          loopCode: this.loop.loopType
        }
      };

      this.income.drug.tdyx.forEach(t => {
        req.playerReqDto.drugList.push(t);
      })

      if (this.recipe.recipeSelect != null) {
        for (const key of Object.keys(this.recipe.recipeSelect)) {
          this.recipe.recipeSelect[key].forEach(t => {
            req.playerReqDto.recipeList.push(t)
          })
        }
      }
      // 添加魔盒导入数据信息
      req.playerReqDto.drugList = req.playerReqDto.drugList.filter(t => t != null);
      req.playerReqDto.equipmentList = req.playerReqDto.equipmentList.filter(t => t != null);
      return req;
    },
    async computeDps(req) {
      // 清理返回值
      this.result.dps.dpsBarY = [];
      this.result.dps.dpsBarX = [];
      this.result.dps.dpsBarAll = [];

      const {
        data: response
      } = await this.$http.post("/api/public/v1/compute/dps", req);
      if (response.success != true) {
        alert("计算出现异常，请联系开发人员。");
      }

      // 计算dps
      var res = response.data
      this.result.dps.dps = res.dps.toFixed(0);

      // 计算属性收益
      for (var attributeIncome in this.result.attributeIncome) {
        for (var attributeIncomeRes of res.attributeIncomeBoList) {
          if (attributeIncomeRes.attributeCode == attributeIncome) {
            this.result.attributeIncome[attributeIncome] = attributeIncomeRes.attributeIncome.toFixed(3);
            break;
          }
        }
      }
      this.initAttributeIncomeEchart();

      // 计算dps柱状图
      for (var mergeSkillDpsBo of res.mergeSkillDpsBoList) {
        this.result.dps.dpsBarY.unshift(mergeSkillDpsBo.skillType);
        this.result.dps.dpsBarX.unshift((mergeSkillDpsBo.proportion).toFixed(2));
        this.result.dps.dpsBarAll.unshift(mergeSkillDpsBo);
      }

      this.initDpsEchart();
      this.cookiesSave();

      return res;
    },
    allBuff() {
      this.income = {
        drug: {
          zqxy: 47165,
          zqxc: 47128,
          fzxy: 47152,
          fzxc: 47115,
          wqms: 12038,
          jyxc: 33493,
          jyxj: 33419,
          tdyx: [47140, 21882, 34864]
        },
        buff: {
          hanRuLei: {
            code: "hanRuLei",
            enable: true,
            num: 1,
            coverage: 1
          },
          zuoXuanYouZhuan: {
            code: "zuoXuanYouZhuan",
            enable: true,
            num: 120,
            coverage: 1
          },
          zhenFen: {
            code: "zhenFen",
            enable: true,
            num: 86,
            coverage: 1
          },
          xiuQi: {
            code: "xiuQi",
            enable: true,
            num: 1,
            coverage: 1
          },
          hanXiaoQianJun: {
            code: "hanXiaoQianJun",
            enable: true,
            num: 1,
            coverage: 0.5
          },
          meiHuaSanNong: {
            code: "meiHuaSanNong",
            enable: true,
            num: 120,
            coverage: 0.8
          },
          xianWangGuDing: {
            code: "xianWangGuDing",
            enable: true,
            num: 1,
            coverage: 0.208
          },
          sheShenHongFa: {
            code: "sheShenHongFa",
            enable: true,
            num: 36,
            coverage: 0.5
          },
          haoLingSanJun: {
            code: "haoLingSanJun",
            enable: true,
            num: 48,
            coverage: 0.1
          },
          jiuZhongXian: {
            code: "jiuZhongXian",
            enable: false,
            num: 1,
            coverage: 1
          },
          shuKuang: {
            code: "shuKuang",
            enable: false,
            num: 1,
            coverage: 0.24
          },
          chaoShengYan: {
            code: "chaoShengYan",
            enable: false,
            num: 24,
            coverage: 0.045
          },
          chaoShengYanGongJi: {
            code: "chaoShengYanGongJi",
            enable: true,
            num: 24,
            coverage: 0.045
          },
          piaoHuang: {
            code: "38581",
            enable: true,
            num: 1,
            coverage: 0.22
          },
        },
        equipment: {
          suit: ["5037", "5038", "1927"],
          weapon: "37247",
          cutCake: "null",
          pendant: "39855"
        },
        greatEnchantment: {
          cap: true,
          clothing: true,
          waistband: true,
          wrister: true,
          shoe: true
        },
        position: "lingXueZiJiZhen"
      };
      this.debuff = {
        chengLongJian: {
          code: "chengLongJian",
          enable: true,
          num: 1,
          coverage: 0.33
        },
        longYin: {
          code: "longYin",
          enable: true,
          num: 1,
          coverage: 1
        },
        qiuSu: {
          code: "qiuSu",
          enable: true,
          num: 1,
          coverage: 1
        },
        xuRuo: {
          code: "xuRuo",
          enable: true,
          num: 1,
          coverage: 1
        }
      };
    },
    clearBuff() {
      this.income = {
        drug: {
          zqxy: null,
          zqxc: null,
          fzxy: null,
          fzxc: null,
          wqms: null,
          jyxc: null,
          jyxj: null,
          tdyx: []
        },
        buff: {
          hanRuLei: {
            code: "hanRuLei",
            enable: false,
            num: 1,
            coverage: 1
          },
          zuoXuanYouZhuan: {
            code: "zuoXuanYouZhuan",
            enable: false,
            num: 120,
            coverage: 1
          },
          zhenFen: {
            code: "zhenFen",
            enable: false,
            num: 86,
            coverage: 1
          },
          xiuQi: {
            code: "xiuQi",
            enable: false,
            num: 1,
            coverage: 1
          },
          hanXiaoQianJun: {
            code: "hanXiaoQianJun",
            enable: false,
            num: 1,
            coverage: 0.5
          },
          meiHuaSanNong: {
            code: "meiHuaSanNong",
            enable: false,
            num: 120,
            coverage: 0.8
          },
          xianWangGuDing: {
            code: "xianWangGuDing",
            enable: false,
            num: 1,
            coverage: 0.208
          },
          sheShenHongFa: {
            code: "sheShenHongFa",
            enable: false,
            num: 36,
            coverage: 0.5
          },
          haoLingSanJun: {
            code: "haoLingSanJun",
            enable: false,
            num: 48,
            coverage: 0.1
          },
          jiuZhongXian: {
            code: "jiuZhongXian",
            enable: false,
            num: 1,
            coverage: 1
          },
          shuKuang: {
            code: "shuKuang",
            enable: false,
            num: 1,
            coverage: 0.24
          },
          chaoShengYan: {
            code: "chaoShengYan",
            enable: false,
            num: 24,
            coverage: 0.045
          },
          chaoShengYanGongJi: {
            code: "chaoShengYanGongJi",
            enable: false,
            num: 24,
            coverage: 0.045
          },
          piaoHuang: {
            code: "38581",
            enable: false,
            num: 1,
            coverage: 0.22
          },
        },
        equipment: {
          suit: null,
          weapon: null,
          cutCake: null,
          pendant: null
        },
        greatEnchantment: {
          cap: false,
          clothing: false,
          waistband: false,
          wrister: false,
          shoe: false
        },
        position: null
      };
      this.debuff = {
        chengLongJian: {
          code: "chengLongJian",
          enable: false,
          num: 1,
          coverage: 0.33
        },
        longYin: {
          code: "longYin",
          enable: false,
          num: 1,
          coverage: 1
        },
        qiuSu: {
          code: "qiuSu",
          enable: false,
          num: 1,
          coverage: 1
        },
        xuRuo: {
          code: "xuRuo",
          enable: false,
          num: 1,
          coverage: 1
        }
      };

    },
    selectChaoShengYan() {
      this.income.buff.chaoShengYanGongJi.enable = false;
    },
    selectChaoShengYanGongJi() {
      this.income.buff.chaoShengYan.enable = false;
    },
    selectTdyx(dataList) {
      this.listData.drug.tdyxOptions.forEach(item => {
        item.disable = false;
      });

      if (dataList && dataList.length) {
        let selectList = [];
        // 找到对应的模型
        dataList.forEach(data => {
          this.listData.drug.tdyxOptions.forEach(item => {
            if (data == item.id) {
              selectList.push(item);
            }
          });
        });

        // 禁用
        selectList.forEach(select => {
          this.listData.drug.tdyxOptions.forEach(item => {
            if ((select.buffId == item.buffId) && (select.id != item.id)) {
              item.disable = true;
            }
          });
        })
      }


    },
    initAttributeIncomeEchart() {
      let getchart = echarts.init(document.getElementById("attributeIncomeBar"));
      getchart.clear();
      let name = "属性收益图";
      var option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: [name],
          bottom: "0%"
        },
        grid: {
          //调整图表上下左右位置
          top: "10%",
          left: "3%",
          right: "8%",
          bottom: "11%",
          containLabel: true
        },

        xAxis: {
          // type: 'category',
          // boundaryGap: false,
          data: ["身法", "破招", "无双", "会心", "破防", "会效", "攻击", "武伤"]
        },
        yAxis: {
          // type: 'value'
          axisLabel: {
            //这种做法就是在y轴的数据的值旁边拼接单位，貌似也挺方便的
            formatter: "{value} %",
          }
        },
        series: [{
          name: name,
          type: "bar",
          data: [
            this.result.attributeIncome.jcsf,
            this.result.attributeIncome.jcpz,
            this.result.attributeIncome.jcws,
            this.result.attributeIncome.jchx,
            this.result.attributeIncome.jcpf,
            this.result.attributeIncome.jchxxg,
            this.result.attributeIncome.jcgj,
            this.result.attributeIncome.wqsh
          ],
          label: {
            normal: {
              show: true,
              position: "top"
            }
          }
        }]
      };

      getchart.setOption(option);
      //随着屏幕大小调节图表


      window.addEventListener("resize", () => {
        getchart.resize();
      });
    },
    initDpsEchart() {
      let dpsBar = echarts.init(document.getElementById("dpsBar"));
      dpsBar.clear();
      var arr_all = this.result.dps.dpsBarAll;

      dpsBar.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (params) { //标签内容
            for (var dpsBo of arr_all) {
              if (params[0].name === dpsBo.skillType) {
                return "伤害:" + dpsBo.damage.toFixed(0) + "<br/>" + "占比:" + dpsBo.proportion.toFixed(2) + "%" +
                  "<br/>" + "技能数:" + dpsBo.num;
              }
            }
            return tips;
          }
        },
        grid: {
          left: "15",
          top: "15",
          bottom: "30",
          containLabel: true
        },
        xAxis: [
          //x轴数据设置
          {
            type: "value",
            name: "伤害量",
            min: 0,
            // max: 150,
            //interval: 30, //间隔数
            // splitNumber: 5,
            axisLabel: {
              formatter: "{value}% "
            },
            splitLine: {
              show: false
            },
            axisLine: {
              //这是y轴文字颜色
              lineStyle: {
                // color: "#7E141C"
              }
            }
          }
        ],
        yAxis: [{
          type: "category",
          offset: 0,
          axisLine: {
            //这是x轴文字颜色
            lineStyle: {
              // color: "#7E141C"
            }
          },
          data: this.result.dps.dpsBarY,
          axisPointer: {
            type: "shadow"
          },
          axisTick: {
            show: false
          }
        }],
        series: [{
          data: this.result.dps.dpsBarX,
          type: "bar",
          barWidth: 18,

          label: {
            normal: {
              show: true,
              formatter: function (params) { //标签内容
                for (var dpsBo of arr_all) {
                  if (params.name === dpsBo.skillType) {
                    return "数量：" + dpsBo.num;
                  }
                }
                return tips;
              },
              position: "right"
            }
          },
          itemStyle: {
            //通常情况下：
            normal: {
              //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
              // color: function(params) {
              //   var colorList = [
              //     "#70DB93",
              //     "#70DB93",
              //     "#7E141C",
              //     "#7E141C",
              //     "#7E141C",
              //     "#7E141C",
              //     "#7E141C",
              //     "#7E141C"
              //   ];
              //   return colorList[params.dataIndex];
              // }
            }
          }
        }]
      });

      window.addEventListener("resize", () => {
        dpsBar.resize();
      });
    },


    // 开启配装器 start
    async peiZhuangOpen() {
      this.$refs.peiZhuangDialogRef.open();
      this.loop.dataSource = "peiZhuang";
    },
    async peiZhuangConfirm(attribute) {
      this.loop.dataSource = "peiZhuang";
      this.attribute.jcgj = attribute.atPhysicsAttackPowerBase;
      this.attribute.wqshMin = attribute.atMeleeWeaponDamageBase;
      this.attribute.wqshMax = attribute.atMeleeWeaponDamageBase + attribute.atMeleeWeaponDamageRand;
      this.attribute.jchx = attribute.atPhysicsCriticalStrikeBaseRate;
      this.attribute.jchxxg = attribute.atPhysicsCriticalDamagePowerBaseKiloNumRate;
      this.attribute.jcws = attribute.atStrainRate;
      this.attribute.jcpf = attribute.atPhysicsOvercomePercent;
      this.attribute.jcpz = attribute.atSurplusValueBase;
      this.attribute.jcsf = attribute.atAgilityBase;
      // 不允许手动输入
      this.attributeFormDisable = true;
    },
    // 开启配装器 end

    // 秘籍 start
    async recipeConfig() {
      this.$refs.recipeDialogRef.open(this.recipe.recipeSelect);
    },
    async recipeConfirm(select) {
      this.recipe.recipeSelect = select;
      this.cookiesSave();
    },
    // 秘籍 end




    // 装备赋值 end



    // 获取页面下拉数据 start
    // 获取初始化数据
    async getInitData() {
      this.fullScreenLock = true;
      let req = {

      };
      const { data: response } = await duanYouApi.getInitData(req);
      // 获取增强小吃
      this.listData.drug = response.data.mainGetInitDataDrugResDto;

      // 获取装备下拉
      this.equip.hatList = response.data.mainGetInitDataEquipResDto.hat.equipList;
      this.equip.jacketList = response.data.mainGetInitDataEquipResDto.jacket.equipList;
      this.equip.beltList = response.data.mainGetInitDataEquipResDto.belt.equipList;
      this.equip.wristList = response.data.mainGetInitDataEquipResDto.wrist.equipList;
      this.equip.bottomsList = response.data.mainGetInitDataEquipResDto.bottoms.equipList;
      this.equip.shoesList = response.data.mainGetInitDataEquipResDto.shoes.equipList;
      this.equip.necklaceList = response.data.mainGetInitDataEquipResDto.necklace.equipList;
      this.equip.pendantList = response.data.mainGetInitDataEquipResDto.pendant.equipList;
      this.equip.ring1List = response.data.mainGetInitDataEquipResDto.ring1.equipList;
      this.equip.ring2List = response.data.mainGetInitDataEquipResDto.ring2.equipList;
      this.equip.primaryWeaponList = response.data.mainGetInitDataEquipResDto.primaryWeapon.equipList;
      this.equip.secondaryWeaponList = response.data.mainGetInitDataEquipResDto.secondaryWeapon.equipList;

      // 重置团队宴席数据
      this.selectTdyx(this.income.drug.tdyx)

      // 获取秘籍信息
      this.$refs.recipeDialogRef.recipeDialogConfirm();

      // 获取装备下拉
      this.$refs.peiZhuangDialogRef.peiZhuang.hat.select = response.data.mainGetInitDataEquipResDto.hat.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.jacket.select = response.data.mainGetInitDataEquipResDto.jacket.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.belt.select = response.data.mainGetInitDataEquipResDto.belt.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.wrist.select = response.data.mainGetInitDataEquipResDto.wrist.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.bottoms.select = response.data.mainGetInitDataEquipResDto.bottoms.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.shoes.select = response.data.mainGetInitDataEquipResDto.shoes.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.necklace.select = response.data.mainGetInitDataEquipResDto.necklace.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.pendant.select = response.data.mainGetInitDataEquipResDto.pendant.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.ring1.select = response.data.mainGetInitDataEquipResDto.ring1.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.ring2.select = response.data.mainGetInitDataEquipResDto.ring2.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.primaryWeapon.select = response.data.mainGetInitDataEquipResDto.primaryWeapon.equipList;
      this.$refs.peiZhuangDialogRef.peiZhuang.secondaryWeapon.select = response.data.mainGetInitDataEquipResDto.secondaryWeapon.equipList;

      // 获取小附魔下拉
      this.$refs.peiZhuangDialogRef.peiZhuang.hat.enchant1.select = response.data.mainGetInitDataEquipResDto.hat.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.jacket.enchant1.select = response.data.mainGetInitDataEquipResDto.jacket.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.belt.enchant1.select = response.data.mainGetInitDataEquipResDto.belt.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.wrist.enchant1.select = response.data.mainGetInitDataEquipResDto.wrist.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.bottoms.enchant1.select = response.data.mainGetInitDataEquipResDto.bottoms.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.shoes.enchant1.select = response.data.mainGetInitDataEquipResDto.shoes.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.necklace.enchant1.select = response.data.mainGetInitDataEquipResDto.necklace.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.pendant.enchant1.select = response.data.mainGetInitDataEquipResDto.pendant.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.ring1.enchant1.select = response.data.mainGetInitDataEquipResDto.ring1.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.ring2.enchant1.select = response.data.mainGetInitDataEquipResDto.ring2.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.primaryWeapon.enchant1.select = response.data.mainGetInitDataEquipResDto.primaryWeapon.enhanceList;
      this.$refs.peiZhuangDialogRef.peiZhuang.secondaryWeapon.enchant1.select = response.data.mainGetInitDataEquipResDto.secondaryWeapon.enhanceList;

      // 获取大附魔下拉
      this.$refs.peiZhuangDialogRef.peiZhuang.hat.enchant2.select = response.data.mainGetInitDataEquipResDto.hat.enchantList;
      this.$refs.peiZhuangDialogRef.peiZhuang.jacket.enchant2.select = response.data.mainGetInitDataEquipResDto.jacket.enchantList;
      this.$refs.peiZhuangDialogRef.peiZhuang.belt.enchant2.select = response.data.mainGetInitDataEquipResDto.belt.enchantList;
      this.$refs.peiZhuangDialogRef.peiZhuang.wrist.enchant2.select = response.data.mainGetInitDataEquipResDto.wrist.enchantList;
      this.$refs.peiZhuangDialogRef.peiZhuang.shoes.enchant2.select = response.data.mainGetInitDataEquipResDto.shoes.enchantList;
      this.fullScreenLock = false;
    },
    // 获取小吃小药下拉选项 start
    async getDrugOption(remark) {
      let req = {
        remark: remark,
      };
      return await this.$http.post("/peiZhuang/getDrugOption", req);
    },
    // 获取小吃小药下拉选项 end

    // 配装器 end
    cookiesSave() {
      localStorage.setItem('attributeFormDisable', JSON.stringify(this.attributeFormDisable));

      localStorage.setItem('attribute', JSON.stringify(this.attribute));

      localStorage.setItem('extraPoint1', JSON.stringify(this.extraPoint));

      localStorage.setItem('income1', JSON.stringify(this.income));

      localStorage.setItem('debuff', JSON.stringify(this.debuff));

      localStorage.setItem('result', JSON.stringify(this.result));

      localStorage.setItem('loop', JSON.stringify(this.loop));

      localStorage.setItem('recipe', JSON.stringify(this.recipe));

      localStorage.setItem('programme', JSON.stringify(this.programme));

    },
    cookiesRead() {
      var attributeFormDisable = localStorage.getItem('attributeFormDisable');
      if (attributeFormDisable != null) {
        this.attributeFormDisable = JSON.parse(attributeFormDisable);
      }

      var attribute = localStorage.getItem('attribute');
      if (attribute != null) {
        this.attribute = JSON.parse(attribute);
      }

      var extraPoint = localStorage.getItem('extraPoint1');
      if (extraPoint != null) {
        this.extraPoint = JSON.parse(extraPoint);
      }

      var income = localStorage.getItem('income1');
      if (income != null) {
        copyUtils.copyMatchingFieldsIter(JSON.parse(income), this.income)
        // this.income = JSON.parse(income);
      }

      var debuff = localStorage.getItem('debuff');
      if (debuff != null) {
        this.debuff = JSON.parse(debuff);
      }

      var result = localStorage.getItem('result');
      if (attributeFormDisable != null) {
        this.result = JSON.parse(result);
      }

      var loop = localStorage.getItem('loop');
      if (loop != null) {
        copyUtils.copyMatchingFieldsIter(JSON.parse(loop), this.loop)

        var loopTypeExist = false
        this.listData.loop.loopTypeOptions
        for (var loopType of this.listData.loop.loopTypeOptions) {
          if (this.loop.loopType == loopType.code) {
            loopTypeExist = true;
          }
        }
        if (!loopTypeExist) {
          this.loop.loopType = "lxgBaoBaiJieYiHenLoop"
          localStorage.setItem('loop', JSON.stringify(this.loop));
        }
      }

      var recipe = localStorage.getItem('recipe');
      if (recipe != null) {
        this.recipe = JSON.parse(recipe);
      }

      var programme = localStorage.getItem('programme');
      if (programme != null && programme != 'undefined') {
        this.programme = JSON.parse(programme);
      }

      this.$refs.peiZhuangDialogRef.cookiesRead();
    },
    // 获取页面下拉数据 start
    // 获取小吃小药下拉选项 start
    async getDrugOption(remark) {
      let req = {
        remark: remark,
      };
      return await this.$http.post("/peiZhuang/getDrugOption", req);
    },
    // 获取小吃小药下拉选项 end

    // 获取页面下拉数据 end
  },
  mounted() {
    this.cookiesRead();
    this.initAttributeIncomeEchart();
    this.initDpsEchart();
    this.getInitData();


    // var isRead = localStorage.getItem("isRead_20240722");
    // if (!isRead) {
    //   this.startGameImportTour();
    //   localStorage.setItem("isRead_20240722", true);
    // }

  }
};
</script>

<style scoped lang="less">
.test {
  text-align: center;
}

.tag-text {
  margin-right: 10px;
  margin-left: 10px;
}

#buff-module {
  border-bottom: 1px solid rgba(224, 230, 237, 0.5);
}

#equipment-module {
  margin-top: 10px;
  border-bottom: 1px solid rgba(224, 230, 237, 0.5);
}

#drug-module {
  margin-top: 10px;
  border-bottom: 1px solid rgba(224, 230, 237, 0.5);
}

#great-enchantment-module {
  margin-top: 10px;
  border-bottom: 1px solid rgba(224, 230, 237, 0.5);
}

#debuff-module {
  margin-top: 10px;
  border-bottom: 1px solid rgba(224, 230, 237, 0.5);
}


#main-container {
  overflow: auto;
}



#input-attribute {
  width: 100%;
  height: 250px;
  text-align: left;
}

.base-attribute-line {
  width: 455px;
  display: flex;
  line-height: 80px;
}

#base-attribute {
  width: 465px;
  height: 450px;
  text-align: left;
  vertical-align: top;
}

#income {
  width: 920px;
  height: 450px;
  text-align: left;
  vertical-align: top;
}

#skillNum {
  width: 600px;

  text-align: left;
  vertical-align: top;
}

#loop {
  width: 280px;

  text-align: left;
  vertical-align: top;
}

#attributeIncome {
  width: 465px;

  text-align: left;
  vertical-align: top;
}

#dpsFont {
  font-size: 40px;
  text-shadow: 0 0 2px black;
  color: red;
  text-align: center;
  // padding-left: 200px;
}



.base-line {
  width: 100%;
  display: flex;
  padding-bottom: 10px;
}

#attributeButtonCompent {
  .el-form-item {
    /deep/ * {
      margin-right: 0px;
      margin-bottom: 5px;
    }
  }
}


/deep/ .el-checkbox {
  margin-left: 10px;
  margin-right: 0px;
}

/deep/ #main-container {
  width: 1440px;
  flex: 0 0 auto;
}

.tag-text {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  box-sizing: border-box;
}

.el-select {
  width: 120px;
}



/deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-tag__close.el-icon-close {
  top: -7px;
}

.base-attribute-input {
  width: 50%;
}

.white-page {
  background-color: rgb(255, 255, 255);
  overflow: auto;
  padding: 15px;
  margin: 5px;
  border-radius: 10px;
  opacity: 0.95;
  font-weight: bolder;
  color: black;
}

.el-header {
  background-color: rgb(30, 31, 35);
  text-align: center;
  justify-content: center;
  font-size: 40px;
  height: 30px;
  color: red;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-footer {
  background-color: #b4adb5;
  color: #333;
  line-height: 60px;
}

.aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
  height: 100%;
  // width: 20vw;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
}

.el-main {
  height: 100%;
  background-color: #dbdbdb;
  color: #333;
  text-align: center;
  line-height: 40px;
}

body>.el-container {
  margin-bottom: 0px;
  margin: 0px;
  overflow: auto;
}

#container {
  overflow: hidden;
  height: 100%;
}

#center-container {
  height: 100%;
}


.bg-img {
  overflow-x: hidden;
  overflow-y: hidden;
  vertical-align: bottom;
  vertical-align: middle;
  vertical-align: top;
  width: 565px;
  height: 100%;
}

.el-row {
  margin-bottom: 20px;
}

.el-row :last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 4px;
  padding: 4px;
}






// opacity: 0.9;
.el-dialog__header {
  .el-dialog__title {
    text-align: center;
    font-weight: 900;
    font-size: 30px;
  }

}

.el-dialog__body {
  padding-top: 0px;
  padding-left: 20px;
  opacity: 0.9;

  .el-dialog-title {
    line-height: 30px;
    text-align: left;
    color: brown;
    margin-left: 20px;
    font-weight: bold;
    font-size: 18px;
    font-family: 宋体;
  }
}






.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

input {
  height: 50px;
}

.floating-component {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px;
  border-radius: 4px;
  z-index: 1000;
  /* 设置 z-index 确保悬浮在顶层 */
}

//该组件默认是没有阴影的 你需要单独在当前页面的style中添加一个css 实现引导阴影效果
.v-tour__target--highlighted {
  // 必须
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7);
}

// //修改vue-tour的默认样式, 需要加上::v-deep，否则不生效
.v-step {}


/deep/ .el-tooltip__popper is-dark {
  font-size: 18px;
}
</style>
../minixs/DuanYou
